import React from "react";

export const extractReactComponent = (m: typeof import(".svg")) => ({
  default: (m.default as any) as React.FC<React.SVGProps<SVGSVGElement>>,
});
